import React from "react";

import Logo from "components/Logo";
import { useWaitlist } from "contexts/waitlist";
import "./footer.scss";

const Footer = () => {
  const { openModal } = useWaitlist();

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <Logo variant="dark" />
          <p className="footer-tagline">
            AI-powered deal scoring for real estate investors.
          </p>
        </div>

        <div className="footer-columns">
          <div className="footer-column">
            <h4 className="footer-column-heading">Product</h4>
            <ul className="footer-links">
              <li>
                <a href="#features">Features</a>
              </li>
              <li>
                <a href="#how-it-works">How It Works</a>
              </li>
              <li>
                <button type="button" onClick={openModal}>
                  Get Early Access
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <span className="footer-copy">
          &copy; {new Date().getFullYear()} NextFlip. All rights reserved.
        </span>
      </div>
    </footer>
  );
};

export default Footer;
